<template>
  <div class="section-container">
    <div class="view-container content_box">
      <StickySearch :offset="0" :trends="trendsData">
      </StickySearch>
      <div class="viw-cont-box">
        <div class="bg-content">
          <!-- <el-image class="bg" src="~/images/trends-bg.webp" fit="contain" /> -->
          <img class="bg" src="~/images/trends-bg.webp" alt="trends-bg" />
          <div class=bg-tip>
            <h1>{{ $t('trends.bgTip') }}</h1>
            <icon-trends class="icon-trends" />
          </div>
        </div>

        <div class="index-container" v-if="locale != 'ja'">
          <ScrollableView :show-arrow-mask="false">
            <NuxtLinkLocale
              v-for="(item, index) of indexList"
              class="index"
              :title="item"
              :key="item"
              :class="{ select: index == categoryCurIndex, 'first-page-index': index === 0 }"
              :to="index === 0 ? '/images-photos/hot' : `/images-photos/hot/${picTitleToHyphen(item)}`" >
              {{ item }}
            </NuxtLinkLocale>
          </ScrollableView>
        </div>



        <div v-if="trendsData.page.length">
          <div class="hot_sea_box">
            <template v-if="loading">
              <TrendsSkeleton hot-num="3" :currentPage="(currentPage - 1)"></TrendsSkeleton>
              <TrendsSkeleton :currentPage="(currentPage - 0.5)" ></TrendsSkeleton>
            </template>

            <template v-else>
              <div v-if="splitTrendsList[0].length" class="hot_l_box hot_new_box">
                <TrendsCodeView hot-num="3" :currentPage="(currentPage - 1)" :host-sea-list="splitTrendsList[0]">
                </TrendsCodeView>
              </div>
              <div v-if="splitTrendsList[1].length" class="hot_l_box hot_last_box">
                <TrendsCodeView :currentPage="(currentPage - 0.5)" :host-sea-list="splitTrendsList[1]">
                </TrendsCodeView>
              </div>
            </template>
          </div>
          <div class="page-row">
            <PageArrow :next="false" v-if="showPrev" :url="prevUrl" @click="prevClick"/>
            <el-pagination class="pagination" v-model:current-page="currentPage" background layout="pager"
            :page-size="20" :total="trendsData?.total" @current-change="handleChangePage" :pager-count="mobileAndTabletCheck() ? 5 : 8"
            hide-on-single-page />
            <PageArrow :next="true" v-if="showNext" :url="nextUrl" @click="nextClick"/>
          </div>
        </div>


        <div v-else class="err_box">
          <div class="desc_box">
            <icon-xxxx class="trends-icon" />
            <p>{{ $t('trends.wrong') }} </p>
          </div>
          <div class="er_btn" @click="retryClick">
            {{ $t('trends.retry') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

import PageArrow from './pageArrow.vue'

const { t, locale, locales } = useI18n()
const localePath = useLocalePath()

const route = useRoute()
const router = useRouter()
// const query = route.query
const currentPage = ref(initCurPage())
function initCurPage() {
  const { category, page } = route.params
  if (category) {
    if (isNaN(Number(category, 10))) {
      if (page) {
        return Number(page, 10)
      } else {
        return 1
      }
    } else {
      return Number(category, 10)
    }
  } else {
    return 1
  }
}

const category = computed(() => {
  const { category } = route.params
  if (category) {
    if (isNaN(Number(category, 10))) {
      return category
    } else {
      return ''
    }
  } else {
    return ''
  }
})

const categoryCurIndex = computed({
  get() {
    const { category } = route.params
    if (!category) {
      return 0
    } else {
      if (isNaN(Number(category, 10))) {
        return indexList.value.findIndex(v => v.toLowerCase() == category.toLowerCase())
      } else {
        return 0
      }
    }
  },
  set(_) {
    return _
  }
})


const trendsQuery = {
  pageNum: currentPage.value,
  pageSize: 20,
  language: locale.value,
  firstCharacter: category.value,
}
const trendsData = ref(null)
const splitTrendsList = computed(() => [
  trendsData.value.page.slice(0, 10),
  trendsData.value.page.slice(10, 20),
])

const loading = ref(true)

try {

  const _trendsData = await useGetTrendsList(trendsQuery)
  trendsData.value = _trendsData.data
  loading.value = false
} catch (error) {

}

const handleChangePage = async () => {
  let path = null
  loading.value = true
  if (category.value === '') {
    path = localePath({
      name: currentPage.value === 1 ? routesName.trending : routesName.trendingPage,
      params: {
        page: currentPage.value
      },
    });
  } else {
    path = localePath({
      name: currentPage.value === 1 ? routesName.trendingCategory : routesName.trendingCategoryPage,
      params: {
        page: currentPage.value,
        category: category.value,
      },
    });
  }
  router.push(path);
}

const retryClick = () => {
  // window.reload()
  window.location.reload()
}


const indexList = ref([
  t("trends.top"),
  t("trends.a"),
  t("trends.b"),
  t("trends.c"),
  t("trends.d"),
  t("trends.e"),
  t("trends.f"),
  t("trends.g"),
  t("trends.h"),
  t("trends.i"),
  t("trends.j"),
  t("trends.k"),
  t("trends.l"),
  t("trends.m"),
  t("trends.n"),
  t("trends.o"),
  t("trends.p"),
  t("trends.q"),
  t("trends.r"),
  t("trends.s"),
  t("trends.t"),
  t("trends.u"),
  t("trends.v"),
  t("trends.w"),
  t("trends.x"),
  t("trends.y"),
  t("trends.z"),
])


const showPrev = computed(() => {
  if (currentPage.value === 1) return false
  if (trendsData?.value?.total <= 20) return false
  return true
})
const showNext = computed(() => {
  if (currentPage.value === Math.ceil((trendsData?.value?.total) / 20)) return false
  if (trendsData?.value?.total <= 20) return false
  return true
})

const modifyUrl = (url, add) => {
    const segments = url.split('/');
    const lastSegment = segments.pop();
    const match = lastSegment.match(/^(\d+)$/);

    if (match) {
        const number = parseInt(match[1], 10);
        if (add) {
          segments.push(number + 1); // 加 1 并替换最后部分
        }else {
          if (number !== 2) {
            segments.push(number - 1)
          }
        }
    } else {
        segments.push(lastSegment); // 保留原最后部分
        segments.push('2'); // 添加 /2
    }

    return segments.join('/'); // 返回修改后的路径
}
const prevUrl = computed(() => {
  return modifyUrl(route.path, false)
})
const nextUrl = computed(() => {
  return modifyUrl(route.path, true)
})
const prevClick = () => {
  currentPage.value -= 1
  handleChangePage()
}
const nextClick = () => {
  currentPage.value += 1
  handleChangePage()
}

function mobileAndTabletCheck() {
  let ua = null
  if (!navigator) {
    const headers = useRequestHeaders()
    ua = headers['user-agent']
  }else {
    ua = navigator?.userAgent || navigator?.vendor || window?.opera
  }
  let check = false
    ; (function (a) {
      try {
        if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      ) {
        check = true
      }
      }catch (e) {
        check = true
      }
    })(ua)
  return check
}

useHead({
  link: [
    { rel:'alternate', hreflang:'en', href: `${useRuntimeConfig().public.domain.en}${routeConstMapping.en.GalleryHot}` },
    { rel:'alternate', hreflang:'fr', href: `${useRuntimeConfig().public.domain.fr}${routeConstMapping.fr.GalleryHot}` },
    { rel:'alternate', hreflang:'es', href: `${useRuntimeConfig().public.domain.es}${routeConstMapping.es.GalleryHot}` },
    { rel:'alternate', hreflang:'pt', href: `${useRuntimeConfig().public.domain.pt}${routeConstMapping.pt.GalleryHot}` },
    { rel:'alternate', hreflang:'ja', href: `${useRuntimeConfig().public.domain.ja}${routeConstMapping.ja.GalleryHot}` },
    { rel:'alternate', hreflang:'x-default', href: `${useRuntimeConfig().public.domain.en}${routeConstMapping.en.GalleryHot}` },
  ],
})

</script>

<style scoped lang="scss">
@media (any-hover: hover) {
  .index-container  {
    .index:hover {

      background: #fff;
    }
  }
}

.section-container {
  position: relative;
  background-color: #FAFAFB;

  @include responseTo(pc-855px) {
    padding: 40px 0 120px;

    .view-container {
      width: 90%;
      max-width: 1200px;
      margin: auto;

      .viw-cont-box {
        margin-top: 34px + 20px;
      }
    }
  }

  @include responseTo(web-854px) {
    padding: 20px 13px 45px;
    margin-left: auto;
    margin-right: auto;

    .view-container {
      margin: auto;

      .viw-cont-box {
        margin-top: 80px + 10px;
      }
    }
  }

}

.bg-content {
  position: relative;

  .bg {
    margin-top: 10px;
    object-fit: cover;
    width: 100%;
    border-radius: 8px;
    max-height: 400px;

    @include responseTo(pc-855px) {
      height: 400px;
    }
  }

  .bg-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @include flex(center);
    width: 100%;
    gap: 10px;
    font-weight: normal;
    font-size: 50px;
    color: #FFFFFF;
    line-height: 60px;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);

    .icon-trends {
      width: 40px;
    }

    @include responseTo(web-854px) {
      font-size: 23px;

      .icon-trends {
        width: 30px;
      }
    }
  }
}

.index-container {
    margin-top: 42px;
    // max-width: min(100% - 60px, 1200px);
    align-self: center;
    display: flex;
    align-items: center;

    &-content {
      display: flex;
      align-items: center;
      overflow-x: auto;
      gap: 10px;
    }

    @include responseTo('web-999px') {
      margin-top: 21px;
      // max-width: calc(100% - 30px);
    }

    .index {
      // min-width: 45px;
      width: 44px;
      height: 44px;
      border-radius: 4px;
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.select {
        min-width: 45px;
        font-weight: 500;
        background-color: rgba(255, 120, 57, 1);
        font-size: 18px;
        color: #FFFFFF;
      }
      &.first-page-index {
        min-width: 44px;
        width: auto;
        padding: 0 8px;
      }

      @include responseTo('web-999px') {
        font-size: 14px;
        &.select {
          font-size: 14px;
        }
      }

      @media (any-hover:hover) {
        &.select:hover {
          background-color: rgba(255, 120, 57, 1);
        }
        &:hover {
          background-color: #F4F5F6;
        }
      }
    }

    .btn {
      padding-left: 40px;
      cursor: pointer;

      @include responseTo("web-766px") {
        padding-left: 20px;
      }

      &-left {
        padding-right: 40px;
        padding-left: 0px;

        @include responseTo("web-766px") {
          padding-right: 20px;
        }
      }


    }
  }

.hot_sea_box {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding-top: 40px;
  gap: 14px;

  .hot_l_box {
    width: 50%;
    max-width: 559px;
  }

  .hot_new_box {}

  @include responseTo(web-854px) {
    flex-direction: column;
    padding-top: 0px;
    gap: 0;

    .hot_l_box {
      width: 100%;
      margin-top: 20px;
      max-width: 100%;
    }

    .hot_new_box {
      margin-right: 0;

      :deep(.l_ul) {
        border-radius: 8px 8px 0 0;
      }
    }

    .hot_last_box {
      margin-top: 0;

      :deep(.l_ul) {
        border-radius: 0 0 8px 8px;
      }
    }
  }

}

.err_box {
  width: 100%;
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .desc_box {
    width: max-content;
    display: flex;
    align-items: center;
    margin-bottom: 50px;

    .trends-icon {
      width: 26px;
      height: 20px;
      margin-right: 10px;
    }

    p {
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 27px;
      text-align: center;
      font-style: normal;
    }
  }

  .er_btn {
    width: 200px;
    height: 50px;
    background: #FF7839;
    border-radius: 8px;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 19px;
    text-align: center;
    font-style: normal;
  }

  @include responseTo(web-854px) {
    height: 252px;

    .desc_box {

      p {
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        line-height: 27px;
        text-align: center;
        font-style: normal;
      }
    }

    .er_btn {
      width: 140px;
      height: 47px;
      border-radius: 8px;
    }
  }
}
.page-row {
  display: flex;
  justify-content: center;
  align-items: center;
  @include responseTo(pc-1000px) {
    margin-top: 80px;
  }

  @include responseTo(web-999px) {
    margin-top: 50px;
  }
}
:deep().el-pagination .el-pager li {
  background-color: #F4F5F6;
}
:deep().arrow {
  padding-left: 40px;
  color: #707177;
  height: 34px;
  width: auto;
  // border: 1px solid;
  padding: 10px 0 10px 10px ;
  cursor: pointer;
  user-select: none;
}
</style>
